module.exports = __webpack_public_path__ + "static/media/1004965.4f2fca41.png";